import React, { useState, useEffect, useRef, useContext } from 'react';
import { Modal } from 'bootstrap';

export function ConfirmDialog(props) {
    const [errorMessage, setErrorMessage] = useState(null);

    const cancelClicked = () => {
        setErrorMessage(null);
        Modal.getInstance("#" + props.id).hide();
    }

    // returning null from the okClicked handler will close the dialog.
    // returning false, will leave it open, with no message.  Otherwise,
    // returning a message will show it as an error message
    const okClicked = async  () => {
        var message = null;
        if (!props.okClicked || (message = await props.okClicked()) == null) {
            setErrorMessage(null);
            Modal.getInstance("#" + props.id).hide();
        } else {
            setErrorMessage(message);
        }
    }

    return (

        <div class="modal fade" id={props.id} aria-labelledby="confirmModal" aria-hidden="true"
            data-bs-backdrop={props.staticBackdrop ? "static" : "true"}
            data-bs-keyboard={props.staticBackdrop ? "false" : "true"}
        >
            <div className={"modal-dialog " + (props.modalSize ?? "") + " modal-dialog-centered modal-dialog-scrollable"}>
                <div class="modal-content"> 
                    <div class="modal-header pb-0">

                        {props.headerText &&
                            <h4 class="auction-grid-header">{props.headerText}</h4>
                        }

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                       <br /> 
                    </div>
                    <div class="divider mt-0 ms-3"></div>
                    <div class="modal-body">
                        {errorMessage &&
                            <div class="alert alert-danger">{errorMessage}</div>
                        }

                        {props.children}

                    </div>
                    <div class="modal-footer">
                        {props.cancelText &&
                            <button type="button" class="btn btn-secondary" onClick={cancelClicked}>{props.cancelText}</button>
                        }
                         
                        <button type="button" class="btn btn-primary" onClick={okClicked}>{props.okText == null ? "Ok" : props.okText}</button>
                         
                        
                    </div>
                </div>
            </div>
        </div>

    );
}
